import { render, staticRenderFns } from "./webcastsRisk.vue?vue&type=template&id=99e0e9c8&scoped=true&"
import script from "./webcastsRisk.vue?vue&type=script&lang=js&"
export * from "./webcastsRisk.vue?vue&type=script&lang=js&"
import style0 from "./webcastsRisk.vue?vue&type=style&index=0&id=99e0e9c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e0e9c8",
  null
  
)

export default component.exports